<template>
  <div class="mt30">
    <div class="d-b-c">
    </div>
    <div class="">
      <div class="Echarts">
        <div id="user-gender-pie" ref="userGenderPie"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import { getGender } from '@/api/education';
  import {
    formatDate
  } from '@/utils/DateTime.js'
  export default {
      data() {
          let endDate = new Date();
          let startDate = new Date();
          startDate.setTime(startDate.getTime() - 3600 * 1000 * 24 * 7);
          return {
              /*是否正在加载*/
              loading: true,
              /*类别*/
              activeName: 'order',
              /*时间快捷选项*/
              pickerOptions: {
                  shortcuts: [{
                      text: '最近一周',
                      onClick(picker) {
                          const end = new Date();
                          const start = new Date();
                          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                          picker.$emit('pick', [start, end]);
                      }
                  },
                      {
                          text: '最近一个月',
                          onClick(picker) {
                              const end = new Date();
                              const start = new Date();
                              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                              picker.$emit('pick', [start, end]);
                          }
                      },
                      {
                          text: '最近三个月',
                          onClick(picker) {
                              const end = new Date();
                              const start = new Date();
                              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                              picker.$emit('pick', [start, end]);
                          }
                      }
                  ]
              },
              datePicker: [formatDate(startDate, 'yyyy-MM-dd'), formatDate(endDate, 'yyyy-MM-dd')],
              /*数据对象*/
              dataList: null,
              /*交易统计图表对象*/
              myChart: null,
              /*图表数据*/
              option: {
                  title: {
                      text: '男女占比',
                      subtext: '男女占比统计',
                      left: 'center'
                  },
                  tooltip: {
                      trigger: 'item'
                  },
                  legend: {
                      orient: 'vertical',
                      left: 'left'
                  },
                  series: [
                      {
                          name: 'Access From',
                          type: 'pie',
                          radius: '50%',
                          data: [
                              {value: 1048, name: 'Search Engine'},
                              {value: 735, name: 'Direct'},
                              {value: 580, name: 'Email'},
                              {value: 484, name: 'Union Ads'},
                              {value: 300, name: 'Video Ads'}
                          ],
                          emphasis: {
                              itemStyle: {
                                  shadowBlur: 10,
                                  shadowOffsetX: 0,
                                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                              }
                          }
                      }
                  ]
              },

          };
      },
      created() {

      },
      mounted() {
          this.myEcharts();
      },
      methods: {

          /*切换*/
          handleClick(e) {
              this.getData();
          },

          /*选择时间*/
          changeDate() {
              this.getData();
          },

          /*创建图表对象*/
          myEcharts() {
              /*获取列表*/
              this.getData();
          },

          /*格式数据*/
          createOption() {
              // 基于准备好的dom，初始化echarts实例
              let chartsDom = this.$refs.userGenderPie
              let myChart = this.$echarts.init(chartsDom);
              let option = Object.assign({},this.option)
              let series = [
                  {
                      name: '统计',
                      type: 'pie',
                      radius: '50%',
                      data: this.dataList,
                      emphasis: {
                          itemStyle: {
                              shadowBlur: 10,
                              shadowOffsetX: 0,
                              shadowColor: 'rgba(0, 0, 0, 0.5)'
                          }
                      }
                  }
              ]
              option.series = series
              console.log(JSON.stringify(option))
              myChart.setOption(option);
              myChart.resize();
          },

          /*获取列表*/
          getData() {
              let self = this;
              self.loading = true;
              getGender({}).then(res => {
                  self.dataList = res.data;
                  self.loading = false;
                  self.createOption();
              }).catch(error => {});
          },
      },
  };
</script>

<style>
  .Echarts {
    box-sizing: border-box;
  }

  .Echarts>div {
    width: 100%;
    height: 400px;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/views/home/part/user-gender-pie.vue